import { toast } from "sonner";
import { SUPPLIERS } from "../../data/adminData";
import { fmt } from "../../data/store";
import { PageTitle, Table, Badge, Btn } from "./ui";

export default function Suppliers() {
  return (
    <div data-testid="admin-suppliers">
      <PageTitle right={<Btn variant="red" onClick={() => toast.info("Jauns piegādātājs (DEMO)", { description: "Pilnajā versijā atvērtos piegādātāja kartītes forma." })} data-testid="supplier-add">+ Pievienot piegādātāju</Btn>}>
        Piegādātāji ({SUPPLIERS.length})
      </PageTitle>
      <Table head={["Piegādātājs", "Kontaktpersona", "E-pasts", "Preces", "Piegādes laiks", "Parāds", ""]}>
        {SUPPLIERS.map((s) => (
          <tr key={s.id} className="border-b border-[#F5F5F5] hover:bg-[#F5F5F5]" data-testid={`supplier-row-${s.id}`}>
            <td className="p-3 font-bold">{s.name}</td>
            <td>{s.contact}</td>
            <td className="text-[#6B6B6B]">{s.email}</td>
            <td>{s.products}</td>
            <td className="text-[#6B6B6B]">{s.leadTime}</td>
            <td>{s.debt > 0 ? <Badge color="amber">{fmt(s.debt)}</Badge> : <Badge color="green">Nav</Badge>}</td>
            <td className="p-3"><Btn variant="outline" onClick={() => toast.success("Iepirkuma pasūtījums izveidots (DEMO)", { description: `PO nosūtīts: ${s.email}` })} data-testid={`supplier-po-${s.id}`}>Izveidot PO</Btn></td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
